var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmlEstoque(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V6.425C3 6.175 3.025 5.9625 3.075 5.7875C3.125 5.6125 3.21667 5.45 3.35 5.3L4.75 3.4C4.88333 3.25 5.0375 3.14583 5.2125 3.0875C5.3875 3.02917 5.59488 3 5.83465 3H18.1654C18.4051 3 18.6083 3.02917 18.775 3.0875C18.9417 3.14583 19.0917 3.25 19.225 3.4L20.65 5.3C20.7833 5.45 20.875 5.6125 20.925 5.7875C20.975 5.9625 21 6.175 21 6.425V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM4.925 5.65H19.05L18.1398 4.5H5.825L4.925 5.65ZM4.5 7.15V19.5H19.5V7.15H4.5ZM12 17.25L15.9 13.35L14.9 12.35L12.75 14.5V9.475H11.25V14.5L9.1 12.35L8.1 13.35L12 17.25Z",
    fill: "url(#paint0_linear_337_352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_352",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlEstoque);
export default __webpack_public_path__ + "static/media/xmlEstoque.a083f60c50c86a4e0900c62e175f2f2b.svg";
export { ForwardRef as ReactComponent };